const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case "CLEAR_CURRENT_EPIRB":
            return initialState;

        case "CURRENT_EPIRB_RETRIEVED":
            {
                return action.data;
            }

        default:
            return state;
    }
}
